import React from 'react';
import background from '../../assets/ask-land.jpg';
import ReusableAskearth from '../../components/ReusableAskearth/ReusableAskearth';

class AskTakeAction extends React.Component {
  render () { 
   return(
  
  <ReusableAskearth             
    
        tag="ASK EARTH"
        description01="How can I lower my carbon footprint?"

        
        background={background}
     />
  
  );
 }
}   

export default AskTakeAction;